import React from 'react';
import { Box, Avatar, Skeleton, useTheme } from '@mui/material';
import Loader from '../../../app/loader/LoaderSvg';

const Thinking = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'flex-start',
        marginBottom: '1rem',
      }}
    >
      <Avatar
        sx={{
          marginRight: '1rem',
          background: 'transparent',
          color: theme.palette.text.primary,
        }}
        alt="ScreenApp"
      >
        <Loader animate />
      </Avatar>
      <Box
        sx={{
          backgroundColor: theme.palette.background.paper,
          borderRadius: '10px',
          padding: '0rem 1rem 0rem 0rem',
          position: 'relative',
          width: '100%',
        }}
      >
        {['100%', '100%', '90%'].map((width) => (
          <Skeleton
            key={width}
            animation="wave"
            width={width}
            sx={{
              backgroundColor: theme.palette.action.hover,
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default Thinking;
